import React from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { toggle } from '../Actions/Cart.action';

const MiniCart = () => {
    const dispatch = useDispatch();
    const { quantity, orderTotal, checkoutUrl, showInfo} = useSelector(
        (state) => state.cart
    );
    const onToggle = () => dispatch(toggle());
    return (
        <div className="cart cart--mini">
            <a
                className="cart__link--block"
                rel="nofollow"
                href={checkoutUrl}
            >
                <i className="cart__icon">
                </i>
                <div className='cart__quantity-container'>
                <span className="cart__quantity">{quantity}</span>
                </div>
                <span className="cart__cost-info-header">
                    {orderTotal}
                </span>
                <span className="cart__title hide">
                    {translate('minicart.checkout')}
                </span>
            </a>
        </div>
    );
};

export default MiniCart;
